import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as fromActions from '../actions';
import { mergeMap, map, catchError, tap } from 'rxjs/operators';
import { EMPTY } from 'rxjs';
import { SidebarService } from '../../../core/services/sidebar.service';



@Injectable()
export class SidebarEffects {

  constructor(
    private actions$: Actions,
    private sidebarService: SidebarService
  ) { }

  loadSidebar$ = createEffect(
    () => this.actions$.pipe(
      ofType(fromActions.loadSidebar),
      mergeMap(
        () => this.sidebarService.find()
          .pipe(
            map(items => fromActions.loadSidebarSuccess({ items })),
            catchError(() => EMPTY)
          )
      )
    )
  );

}
